import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getVesselTypeMasterList,
  addVesselMastersList,
  setIsOpenModelAddVesselMaster,
} from "../../../redux/actions/mastersAction";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const AddVesselMasterModel = (Props) => {
  const dispatch = useDispatch();

  const CompanyID = localStorage.getItem("companyID");

  const VesselMasterModel = useSelector(
    (state) => state?.masters?.models?.AddVesselMasterModel
  );
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );

  const vesselTypeMasterData = useSelector(
    (state) => state?.masters?.vesselTypeMasterData
  );
  const [VesselType, setVesselType] = useState("");

  const [ImoNumber, setImoNumber] = useState("");

  const handleChangeImoNumber = (event) => {
    setImoNumber(event.target.value);
  };

  const handleChangeVesselType = (event) => {
    setVesselType(event.target.value);
  };

  const [VesselName, setVesselName] = useState("");

  const handleChangeVesselName = (event) => {
    setVesselName(event.target.value);
  };

  const handleSaveVessel = async (event) => {
    event.preventDefault();
    if (VesselType !== "" && VesselName !== "") {
      dispatch(
        addVesselMastersList({
          name: VesselName,
          imo_number: "12345",
          vessel_type_id: VesselType,
          company_id: CompanyID,
        })
      );
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  useEffect(() => {
    if (!VesselMasterModel) {
      setVesselType("");
      setVesselName("");
    }
  }, [VesselMasterModel]);

  return (
    <Modal
      open={VesselMasterModel}
      onClose={() => dispatch(setIsOpenModelAddVesselMaster(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add New Vessel
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => dispatch(setIsOpenModelAddVesselMaster(false))}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                value={VesselType}
                onChange={handleChangeVesselType}
                sx={{
                  width: "50%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Vessel Type
                </MenuItem>
                {vesselTypeMasterData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Enter Vessel Name"
                type="text"
                value={VesselName}
                onChange={handleChangeVesselName}
                sx={{
                  width: "50%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Imo Number"
                type="number"
                value={ImoNumber}
                onChange={handleChangeImoNumber}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box> */}
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={() => dispatch(setIsOpenModelAddVesselMaster(false))}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveVessel}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddVesselMasterModel;
